import { StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "../../genericPages/components/FindifyTopBarOverlay";
import { BasePage } from "../../genericPages/helpers/BasePage";
import React from "react";
import { PlaceText } from "../../genericPages/components/PlaceText";



const ProfileHeader = () => {
    const insets = useSafeAreaInsets();
    return <View style={{
        // position: 'absolute',
        // top: 0,
        width: '100%',
        zIndex: 1
    }}>

        <View
            style={{
                paddingTop: insets.top
            }}
        >
            <PlaceText>Header</PlaceText>
        </View>
    </View>
}

export const StoreTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();

    return (<BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <PlaceText>StoreTab</PlaceText>
        {/* <Button
            title="Go to Jane's profile"
            onPress={() =>
                navigation.push('Profile', { name: 'Jane' })
            }
            />
        */}
    </BasePage>);
};


const styles = StyleSheet.create({
    sectionContainer: {
        marginTop: 32,
        paddingHorizontal: 24,
    },
    sectionTitle: {
        fontSize: 24,
        fontWeight: '600',
    },
    sectionDescription: {
        marginTop: 8,
        fontSize: 18,
        fontWeight: '400',
    },
    highlight: {
        fontWeight: '700',
    },

    container: {
        flex: 1,
    },
    small: {
        width: 200,
        height: 200,
        marginBottom: 10,
        marginRight: 10,
        backgroundColor: 'skyblue',
    },
    large: {
        width: 300,
        height: 300,
        marginBottom: 10,
        marginRight: 10,
        backgroundColor: 'steelblue',
    },
});